var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "figure",
    {
      staticClass: "role-button",
      attrs: { "data-role": _vm.role },
      on: {
        click: function ($event) {
          return _vm.onClick(_vm.role)
        },
      },
    },
    [
      _c("img", { staticClass: "role-button__icon", attrs: { src: _vm.src } }),
      _vm._v(" "),
      _c("figcaption", { staticClass: "role-button__name" }, [
        _vm._v(_vm._s(_vm.role)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }